import React from 'react'
import PropTypes from 'prop-types'

const Phone = ({ width, height }) => (
  <svg viewBox="0 0 26 26" width={width} height={height}>
    <defs>
      <rect id="path-1" x="0" y="0" width={width} height={height} />
    </defs>
    <g
      id="Designs"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g transform="translate(-174.000000, -609.000000)">
        <g id="Group" transform="translate(16.000000, 582.000000)">
          <g transform="translate(16.000000, 24.000000)">
            <g transform="translate(139.000000, 0.000000)">
              <use id="Padding" fillOpacity="0" fill="#FFFFFF" />
              <g
                id="phone"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.5"
              >
                <g transform="translate(4.000000, 4.000000)" id="Shape">
                  <path d="M23.9992464,17.968604 L23.9992464,21.5815703 C24.0020047,22.2597784 23.7181403,22.9077197 23.2173907,23.3662129 C22.7166411,23.8247062 22.0454148,24.0512593 21.3686133,23.9902145 C17.6553586,23.5875383 14.0885161,22.3211982 10.9546849,20.2929457 C8.03906026,18.4439064 5.56711951,15.9768623 3.71441028,13.0670131 C1.67503978,9.92518244 0.405898002,6.34809361 0.00980308777,2.62554057 C-0.051168218,1.95217077 0.174244215,1.28422976 0.630977358,0.784880041 C1.0877105,0.285530325 1.73370553,0.00075512101 2.41116085,0 L6.03129817,0 C7.24267341,-0.0117804839 8.27518097,0.874417086 8.44472305,2.07155241 C8.59752062,3.22778165 8.88088861,4.36304843 9.28942176,5.45569749 C9.62094791,6.33590644 9.40890448,7.32818503 8.74640116,7.99681711 L7.21387636,9.52630617 C8.93169846,12.5413817 11.4330911,15.0378194 14.454151,16.7522387 L15.9866758,15.2227497 C16.656635,14.5615587 17.6508831,14.3499353 18.5328391,14.6808047 C19.6276568,15.0885286 20.7651769,15.3713353 21.923701,15.5238302 C23.137126,15.6946757 24.0296435,16.7459673 23.9992464,17.968604 Z" />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
)

Phone.defaultProps = {
  width: 50,
  height: 50,
}

Phone.propTypes = {
  width: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
}

export default Phone
